// extracted by mini-css-extract-plugin
export default {"dndContainer":"FileUpload-module__dndContainer--HBh_d","spinner":"FileUpload-module__spinner--O8YM4","error":"FileUpload-module__error--Fgwzv"};